import { Suspense, lazy } from 'react';
import './App.css';
import { LicenseInfo } from '@mui/x-license';
import { AutosaveProvider } from './cpts/Form/Autosave/AutosaveContext';
import cuteSadGnomeSrc from './assets/art/cute-sad-gnome.webp'; // KEEEEEP
import { getLocalStorageMB } from './libTs/depless';

// Lazy-load a component based on the tenant ID
// Define the TenantAppName type and component paths

export type TenantAppName =
  | 'BELONGING'
  | 'DEMO'
  | 'EHC'
  | 'EHC2'
  | 'FC'
  | 'KS'
  | 'MNHOUSTON'
  | 'MO'
  | 'NCSTATE'
  | 'SCOTT'
  | 'SCOTT2'
  | 'SG'
  | 'TEST'
  | 'zzzzzzzzz';

export type TenantAppNameLowercase = Lowercase<TenantAppName>;

const componentPaths: {
  [key in TenantAppName]: string;
} = {
  BELONGING: './_tenant_apps/BELONGING/App',
  DEMO: './_tenant_apps/DEMO/App',
  EHC: './_tenant_apps/EHC/App',
  EHC2: './_tenant_apps/EHC2/App',
  FC: './_tenant_apps/FC/App',
  KS: './_tenant_apps/KS/App',
  MNHOUSTON: './_tenant_apps/MNHOUSTON/App',
  MO: './_tenant_apps/MO/App',
  NCSTATE: './_tenant_apps/NCSTATE/App',
  SCOTT: './_tenant_apps/SCOTT/App',
  SCOTT2: './_tenant_apps/SCOTT2/App',
  SG: './_tenant_apps/SG/App',
  TEST: './_tenant_apps/TEST/App',
  zzzzzzzzz: './_tenant_apps/zzzzzzzzz/App',
};

// Access the frontend tenant environment variable
const tenantDir = process.env.REACT_APP_FRONTEND_TENANT_DIR || 'EHC';
console.log('REACT_APP_FRONTEND_TENANT_DIR:', tenantDir);

const FRONTEND_TENANT_DIR = tenantDir as TenantAppName;

const componentPath = componentPaths[FRONTEND_TENANT_DIR];
if (!componentPath) {
  console.warn(
    `No component path found for tenant ID ${FRONTEND_TENANT_DIR}, using default component.`
  );
}

// Use dynamic import with static string to allow Webpack to handle it correctly
const TenantRootComponent = componentPath
  ? lazy(() => import(`${componentPath}`))
  : () => (
      <div>
        ERROR: componentPath '{componentPath}' import failed. (For '{tenantDir}
        ')
      </div>
    );
console.log('TenantRootComponent', TenantRootComponent);

function App() {
  return (
    <AutosaveProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <TenantRootComponent />
      </Suspense>
      {/* prettier-ignore */}
      <img src={cuteSadGnomeSrc} alt="Cute sad gnome" width={'1px'} height={'1px'} style={{opacity: 0, display: 'none'}} />
    </AutosaveProvider>
  );
}

LicenseInfo.setLicenseKey(
  '6b0286321fcdebb1f0592fa8339ab1e2Tz0xMDM0MzEsRT0xNzY0ODE5NzE2MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
);

export default App;

declare global {
  interface Window {
    tools: {
      getLocalStorageMB: () => number;
    };
    FRONTEND_TENANT_DIR?: string;
  }
}
window.tools = { getLocalStorageMB };
window.FRONTEND_TENANT_DIR = tenantDir;
